import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import styles from  "../styles/MainEvents.module.css";
import defaultImg from "../assets/defaultPoster.png";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import mainEvents from "../data/mainevents.json";
import Box from "@mui/material/Box";

let filteredEvents = mainEvents.filter((event) => {
    let today = new Date();
    let eventDate = new Date(event.endDate + " " + event.endTime );
    return today < eventDate;
})

export default function MainEvents() {
    const navigate = useNavigate();

    return (
        <div className={styles.sliderContainer}>
            <CarouselProvider
                naturalSlideWidth={100}
                totalSlides={filteredEvents.length}
                interval={5000}
                isPlaying
                infinite
                isIntrinsicHeight
            >
                <div>
                    <Slider>
                        {filteredEvents.map((event, i) => (
                            <Slide index={i} key={event.id}>
                                <div className={styles.cardContainer} key={event.id}>
                                    <img style={{width: "100%", height: "auto", maxWidth: "380px"}} src={event.posterImage || defaultImg} alt="Event" onClick={() => navigate(`/events/${event.id}`)} />
                                    <Box className={styles.eventDetails} sx={{ margin: "0 40px", display: { xs: 'none', md: 'block' } }}>
                                        <h3 style={{color: "#4c1864", fontSize: "28px"}}>{event.eventName}</h3>
                                        <h4>From {event.startDate} to {event.endDate}</h4>
                                        <h4 style={{marginBottom:"10px"}}>{event.location.address}</h4>
                                        <div style={{
                                            fontSize: "0.9rem",
                                            color: "black",
                                            maxHeight:"80px",
                                            overflow:"hidden",
                                            letterSpacing: "1px",
                                            lineHeight: "2",
                                            marginTop: "5px",
                                            marginBottom: "15px"
                                        }} dangerouslySetInnerHTML={{__html: event.intro}} />

                                        <Button
                                            variant="filled"
                                            className={styles.moreDetailsBtn}
                                            onClick={() => navigate(`/events/${event.id}`)}
                                            style={{marginTop: "10px"}}
                                        >
                                            {"More Details"}
                                        </Button>
                                    </Box>
                                </div>
                                <Box sx={{ textAlign: "center", marginTop: "20px",  width: "100%", display: { md: 'none' } }}>
                                    <Button
                                        variant="filled"
                                        className={styles.moreDetailsBtn}
                                        onClick={() => navigate(`/events/${event.id}`)}
                                    >
                                        {"More Details"}
                                    </Button>
                                </Box>
                            </Slide>
                        ))}
                    </Slider>
                    {filteredEvents.length > 1 && (
                        <div>
                            <ButtonBack className={styles.backButton}><ArrowBackIosIcon /></ButtonBack>
                            <ButtonNext className={styles.forwardButton}><ArrowForwardIosIcon /></ButtonNext>
                        </div>    
                    )}
                </div>
            </CarouselProvider>
        </div>
    );
}

